module.exports = __webpack_public_path__ + "img/ic_18Plus.c8ec9589.svg";